import {
  CHANNEL_TYPING_START,
  CHANNEL_TYPING_STOP,
  WS_SEND_MESSAGE,
} from '@common/constants/webSockets'
import {
  AimNoteScopeType,
  AimPinTargetType,
  ChannelNotificationLevel,
  ChannelVisibility,
} from '@common/interfaces/channels'
import { ThreadsFilter } from '@common/interfaces/threadsFilter'
import { RawDraftContentState } from 'draft-js'
import { IApi } from '../../api'
import {
  IScheduleChannelMessageParams,
  IScheduleFirstMessageParams,
  ISearchConversationsParams,
  ISearchMessagesParams,
  ISendChannelMessageParams,
  ISendVoiceMemoParams,
  IUpdateScheduledChannelMessageParams,
} from '../../api/channels'
import { arcPageStateFor } from '../../helpers/arcPageState'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'
import { fetchAttachmentLink } from './attachmentLinkRequest'

export const prefix = 'channels'

export const [LIST_CHANNELS_REQUEST, LIST_CHANNELS_SUCCESS, LIST_CHANNELS_FAILURE] =
  createRequestTypes(prefix, 'LIST_CHANNELS')

export const [BROWSE_CHANNELS_REQUEST, BROWSE_CHANNELS_SUCCESS, BROWSE_CHANNELS_FAILURE] =
  createRequestTypes(prefix, 'BROWSE_CHANNELS')

export const [
  GET_SETTINGS_CHANNEL_REQUEST,
  GET_SETTINGS_CHANNEL_SUCCESS,
  GET_SETTINGS_CHANNEL_FAILURE,
] = createRequestTypes(prefix, 'GET_SETTINGS_CHANNEL')

export const [GET_CHANNEL_REQUEST, GET_CHANNEL_SUCCESS, GET_CHANNEL_FAILURE] = createRequestTypes(
  prefix,
  'GET_CHANNEL',
)

export const [CREATE_CHANNEL_REQUEST, CREATE_CHANNEL_SUCCESS, CREATE_CHANNEL_FAILURE] =
  createRequestTypes(prefix, 'CREATE_CHANNEL')

export const [UPDATE_CHANNEL_REQUEST, UPDATE_CHANNEL_SUCCESS, UPDATE_CHANNEL_FAILURE] =
  createRequestTypes(prefix, 'UPDATE_CHANNEL')

export const [ARCHIVE_CHANNEL_REQUEST, ARCHIVE_CHANNEL_SUCCESS, ARCHIVE_CHANNEL_FAILURE] =
  createRequestTypes(prefix, 'ARCHIVE_CHANNEL')

export const [OPEN_DM_REQUEST, OPEN_DM_SUCCESS, OPEN_DM_FAILURE] = createRequestTypes(
  prefix,
  'OPEN_DM',
)

export const [FIND_DM_REQUEST, FIND_DM_SUCCESS, FIND_DM_FAILURE] = createRequestTypes(
  prefix,
  'FIND_DM',
)

export const [JOIN_CHANNEL_REQUEST, JOIN_CHANNEL_SUCCESS, JOIN_CHANNEL_FAILURE] =
  createRequestTypes(prefix, 'JOIN_CHANNEL')

export const [LEAVE_CHANNEL_REQUEST, LEAVE_CHANNEL_SUCCESS, LEAVE_CHANNEL_FAILURE] =
  createRequestTypes(prefix, 'LEAVE_CHANNEL')

export const [LIST_MEMBERS_REQUEST, LIST_MEMBERS_SUCCESS, LIST_MEMBERS_FAILURE] =
  createRequestTypes(prefix, 'LIST_MEMBERS')

export const [ADD_MEMBERS_REQUEST, ADD_MEMBERS_SUCCESS, ADD_MEMBERS_FAILURE] = createRequestTypes(
  prefix,
  'ADD_MEMBERS',
)

export const [REMOVE_MEMBER_REQUEST, REMOVE_MEMBER_SUCCESS, REMOVE_MEMBER_FAILURE] =
  createRequestTypes(prefix, 'REMOVE_MEMBER')

export const [UPDATE_SETTINGS_REQUEST, UPDATE_SETTINGS_SUCCESS, UPDATE_SETTINGS_FAILURE] =
  createRequestTypes(prefix, 'UPDATE_SETTINGS')

export const [CREATE_SHARE_LINK_REQUEST, CREATE_SHARE_LINK_SUCCESS, CREATE_SHARE_LINK_FAILURE] =
  createRequestTypes(prefix, 'CREATE_SHARE_LINK')

export const [RESOLVE_SHARE_REQUEST, RESOLVE_SHARE_SUCCESS, RESOLVE_SHARE_FAILURE] =
  createRequestTypes(prefix, 'RESOLVE_SHARE')

export const [JOIN_SHARE_REQUEST, JOIN_SHARE_SUCCESS, JOIN_SHARE_FAILURE] = createRequestTypes(
  prefix,
  'JOIN_SHARE',
)

export const [LIST_MESSAGES_REQUEST, LIST_MESSAGES_SUCCESS, LIST_MESSAGES_FAILURE] =
  createRequestTypes(prefix, 'LIST_MESSAGES')

export const [
  GET_MESSAGE_CONTEXT_REQUEST,
  GET_MESSAGE_CONTEXT_SUCCESS,
  GET_MESSAGE_CONTEXT_FAILURE,
] = createRequestTypes(prefix, 'GET_MESSAGE_CONTEXT')

export const [SEND_MESSAGE_REQUEST, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_FAILURE] =
  createRequestTypes(prefix, 'SEND_MESSAGE')

export const [SEND_VOICE_MEMO_REQUEST, SEND_VOICE_MEMO_SUCCESS, SEND_VOICE_MEMO_FAILURE] =
  createRequestTypes(prefix, 'SEND_VOICE_MEMO')

export const [
  RETRY_VOICE_MEMO_TRANSCRIPTION_REQUEST,
  RETRY_VOICE_MEMO_TRANSCRIPTION_SUCCESS,
  RETRY_VOICE_MEMO_TRANSCRIPTION_FAILURE,
] = createRequestTypes(prefix, 'RETRY_VOICE_MEMO_TRANSCRIPTION')

export const [EDIT_MESSAGE_REQUEST, EDIT_MESSAGE_SUCCESS, EDIT_MESSAGE_FAILURE] =
  createRequestTypes(prefix, 'EDIT_MESSAGE')

export const [DELETE_MESSAGE_REQUEST, DELETE_MESSAGE_SUCCESS, DELETE_MESSAGE_FAILURE] =
  createRequestTypes(prefix, 'DELETE_MESSAGE')

export const [
  DISMISS_LINK_PREVIEW_REQUEST,
  DISMISS_LINK_PREVIEW_SUCCESS,
  DISMISS_LINK_PREVIEW_FAILURE,
] = createRequestTypes(prefix, 'DISMISS_LINK_PREVIEW')

export const [
  ACCEPT_TASK_SUGGESTION_REQUEST,
  ACCEPT_TASK_SUGGESTION_SUCCESS,
  ACCEPT_TASK_SUGGESTION_FAILURE,
] = createRequestTypes(prefix, 'ACCEPT_TASK_SUGGESTION')

export const [
  DISMISS_TASK_SUGGESTION_REQUEST,
  DISMISS_TASK_SUGGESTION_SUCCESS,
  DISMISS_TASK_SUGGESTION_FAILURE,
] = createRequestTypes(prefix, 'DISMISS_TASK_SUGGESTION')

export const [MARK_READ_REQUEST, MARK_READ_SUCCESS, MARK_READ_FAILURE] = createRequestTypes(
  prefix,
  'MARK_READ',
)

export const [MARK_UNREAD_REQUEST, MARK_UNREAD_SUCCESS, MARK_UNREAD_FAILURE] = createRequestTypes(
  prefix,
  'MARK_UNREAD',
)

export const [ADD_REACTION_REQUEST, ADD_REACTION_SUCCESS, ADD_REACTION_FAILURE] =
  createRequestTypes(prefix, 'ADD_REACTION')

export const [REMOVE_REACTION_REQUEST, REMOVE_REACTION_SUCCESS, REMOVE_REACTION_FAILURE] =
  createRequestTypes(prefix, 'REMOVE_REACTION')

export const [SEARCH_MESSAGES_REQUEST, SEARCH_MESSAGES_SUCCESS, SEARCH_MESSAGES_FAILURE] =
  createRequestTypes(prefix, 'SEARCH_MESSAGES')

export const [
  SEARCH_CONVERSATIONS_REQUEST,
  SEARCH_CONVERSATIONS_SUCCESS,
  SEARCH_CONVERSATIONS_FAILURE,
] = createRequestTypes(prefix, 'SEARCH_CONVERSATIONS')

export const [UPLOAD_ATTACHMENT_REQUEST, UPLOAD_ATTACHMENT_SUCCESS, UPLOAD_ATTACHMENT_FAILURE] =
  createRequestTypes(prefix, 'UPLOAD_ATTACHMENT')

export const [PIN_MESSAGE_REQUEST, PIN_MESSAGE_SUCCESS, PIN_MESSAGE_FAILURE] = createRequestTypes(
  prefix,
  'PIN_MESSAGE',
)

export const [START_ZOOM_MEETING_REQUEST, START_ZOOM_MEETING_SUCCESS, START_ZOOM_MEETING_FAILURE] =
  createRequestTypes(prefix, 'START_ZOOM_MEETING')

export const [ARC_PROGRESS_REQUEST, ARC_PROGRESS_SUCCESS, ARC_PROGRESS_FAILURE] =
  createRequestTypes(prefix, 'ARC_PROGRESS')

export const [ARC_RUNS_REQUEST, ARC_RUNS_SUCCESS, ARC_RUNS_FAILURE] = createRequestTypes(
  prefix,
  'ARC_RUNS',
)

export const [CANCEL_ARC_RUN_REQUEST, CANCEL_ARC_RUN_SUCCESS, CANCEL_ARC_RUN_FAILURE] =
  createRequestTypes(prefix, 'CANCEL_ARC_RUN')

export const [ARC_PLAN_REQUEST, ARC_PLAN_SUCCESS, ARC_PLAN_FAILURE] = createRequestTypes(
  prefix,
  'ARC_PLAN',
)

export const [
  LIST_CONVERSATION_GROUPS_REQUEST,
  LIST_CONVERSATION_GROUPS_SUCCESS,
  LIST_CONVERSATION_GROUPS_FAILURE,
] = createRequestTypes(prefix, 'LIST_CONVERSATION_GROUPS')

export const [LIST_CONVERSATIONS_REQUEST, LIST_CONVERSATIONS_SUCCESS, LIST_CONVERSATIONS_FAILURE] =
  createRequestTypes(prefix, 'LIST_CONVERSATIONS')

export const [
  LIST_RECENT_CONVERSATIONS_REQUEST,
  LIST_RECENT_CONVERSATIONS_SUCCESS,
  LIST_RECENT_CONVERSATIONS_FAILURE,
] = createRequestTypes(prefix, 'LIST_RECENT_CONVERSATIONS')

export const [LIST_PEOPLE_REQUEST, LIST_PEOPLE_SUCCESS, LIST_PEOPLE_FAILURE] = createRequestTypes(
  prefix,
  'LIST_PEOPLE',
)

export const [SET_PIN_REQUEST, SET_PIN_SUCCESS, SET_PIN_FAILURE] = createRequestTypes(
  prefix,
  'SET_PIN',
)

export const [
  ARCHIVE_CONVERSATION_REQUEST,
  ARCHIVE_CONVERSATION_SUCCESS,
  ARCHIVE_CONVERSATION_FAILURE,
] = createRequestTypes(prefix, 'ARCHIVE_CONVERSATION')

export const [
  CREATE_CHANNEL_CONVERSATION_REQUEST,
  CREATE_CHANNEL_CONVERSATION_SUCCESS,
  CREATE_CHANNEL_CONVERSATION_FAILURE,
] = createRequestTypes(prefix, 'CREATE_CHANNEL_CONVERSATION')

export const [GET_CHANNEL_HOME_REQUEST, GET_CHANNEL_HOME_SUCCESS, GET_CHANNEL_HOME_FAILURE] =
  createRequestTypes(prefix, 'GET_CHANNEL_HOME')

export const [GET_PERSON_HOME_REQUEST, GET_PERSON_HOME_SUCCESS, GET_PERSON_HOME_FAILURE] =
  createRequestTypes(prefix, 'GET_PERSON_HOME')

export const [GET_ARC_HOME_REQUEST, GET_ARC_HOME_SUCCESS, GET_ARC_HOME_FAILURE] =
  createRequestTypes(prefix, 'GET_ARC_HOME')

export const [SAVE_AIM_NOTE_REQUEST, SAVE_AIM_NOTE_SUCCESS, SAVE_AIM_NOTE_FAILURE] =
  createRequestTypes(prefix, 'SAVE_AIM_NOTE')

export const [SET_ARC_MODEL_REQUEST, SET_ARC_MODEL_SUCCESS, SET_ARC_MODEL_FAILURE] =
  createRequestTypes(prefix, 'SET_ARC_MODEL')

export const [
  LIST_SCHEDULED_RUN_GROUPS_REQUEST,
  LIST_SCHEDULED_RUN_GROUPS_SUCCESS,
  LIST_SCHEDULED_RUN_GROUPS_FAILURE,
] = createRequestTypes(prefix, 'LIST_SCHEDULED_RUN_GROUPS')

export const [
  LIST_SCHEDULED_MESSAGES_REQUEST,
  LIST_SCHEDULED_MESSAGES_SUCCESS,
  LIST_SCHEDULED_MESSAGES_FAILURE,
] = createRequestTypes(prefix, 'LIST_SCHEDULED_MESSAGES')

export const [SCHEDULE_MESSAGE_REQUEST, SCHEDULE_MESSAGE_SUCCESS, SCHEDULE_MESSAGE_FAILURE] =
  createRequestTypes(prefix, 'SCHEDULE_MESSAGE')

export const [
  UPDATE_SCHEDULED_MESSAGE_REQUEST,
  UPDATE_SCHEDULED_MESSAGE_SUCCESS,
  UPDATE_SCHEDULED_MESSAGE_FAILURE,
] = createRequestTypes(prefix, 'UPDATE_SCHEDULED_MESSAGE')

export const [
  CANCEL_SCHEDULED_MESSAGE_REQUEST,
  CANCEL_SCHEDULED_MESSAGE_SUCCESS,
  CANCEL_SCHEDULED_MESSAGE_FAILURE,
] = createRequestTypes(prefix, 'CANCEL_SCHEDULED_MESSAGE')

export const [
  SEND_SCHEDULED_MESSAGE_NOW_REQUEST,
  SEND_SCHEDULED_MESSAGE_NOW_SUCCESS,
  SEND_SCHEDULED_MESSAGE_NOW_FAILURE,
] = createRequestTypes(prefix, 'SEND_SCHEDULED_MESSAGE_NOW')

export const [ATTACHMENT_LINK_REQUEST, ATTACHMENT_LINK_SUCCESS, ATTACHMENT_LINK_FAILURE] =
  createRequestTypes(prefix, 'ATTACHMENT_LINK')

export const [
  ATTACHMENT_VIDEO_URL_REQUEST,
  ATTACHMENT_VIDEO_URL_SUCCESS,
  ATTACHMENT_VIDEO_URL_FAILURE,
] = createRequestTypes(prefix, 'ATTACHMENT_VIDEO_URL')

// Local (non-promise) actions.
export const SET_ACTIVE_CHANNEL = `${prefix}/SET_ACTIVE_CHANNEL`
export const CLEAR_SEARCH = `${prefix}/CLEAR_SEARCH`
export const DISMISS_MENTION_INVITE = `${prefix}/DISMISS_MENTION_INVITE`
export const INVALIDATE_LOADED_CONVERSATIONS = `${prefix}/INVALIDATE_LOADED_CONVERSATIONS`
export const SET_SIDE_PANEL = `${prefix}/SET_SIDE_PANEL`
export const SET_THREADS_FILTER = `${prefix}/SET_THREADS_FILTER`
export const SHOW_MORE_THREADS = `${prefix}/SHOW_MORE_THREADS`
export const SHOW_FEWER_THREADS = `${prefix}/SHOW_FEWER_THREADS`
export const OPEN_SPLIT_PANE = `${prefix}/OPEN_SPLIT_PANE`
export const CLOSE_SPLIT_PANE = `${prefix}/CLOSE_SPLIT_PANE`
export const CLOSE_SPLIT_PANES = `${prefix}/CLOSE_SPLIT_PANES`
export const OPEN_EMBEDDED_CONVERSATION = `${prefix}/OPEN_EMBEDDED_CONVERSATION`
export const CLOSE_EMBEDDED_CONVERSATION = `${prefix}/CLOSE_EMBEDDED_CONVERSATION`
export const SET_EMBEDDED_SIDE_PANEL = `${prefix}/SET_EMBEDDED_SIDE_PANEL`

// --- Channels ---

export const listChannels = createAction((params?: { includeArchived?: boolean }) => ({
  type: [LIST_CHANNELS_REQUEST, LIST_CHANNELS_SUCCESS, LIST_CHANNELS_FAILURE],
  promise: (api: IApi) => api.channels.list(params),
  params,
}))

export const browseChannels = createAction(
  (params?: { search?: string; includeJoined?: boolean; page?: number; perPage?: number }) => ({
    type: [BROWSE_CHANNELS_REQUEST, BROWSE_CHANNELS_SUCCESS, BROWSE_CHANNELS_FAILURE],
    promise: (api: IApi) => api.channels.browse(params),
    params,
  }),
)

/**
 * The channel a settings dialog is open on.
 *
 * Deliberately not `getChannel`: that fills `activeChannel`, which is the open
 * *conversation* and is guarded against a detail for anything else — so a
 * group's detail fetched while one of its threads is open was discarded and the
 * dialog never mounted. The dialog's subject is not the page's navigation.
 */
export const getSettingsChannel = createAction((channelId: string) => ({
  type: [GET_SETTINGS_CHANNEL_REQUEST, GET_SETTINGS_CHANNEL_SUCCESS, GET_SETTINGS_CHANNEL_FAILURE],
  promise: (api: IApi) => api.channels.get(channelId),
  params: { channelId },
}))

export const getChannel = createAction((channelId: string) => ({
  type: [GET_CHANNEL_REQUEST, GET_CHANNEL_SUCCESS, GET_CHANNEL_FAILURE],
  promise: (api: IApi) => api.channels.get(channelId),
  params: { channelId },
}))

export const createChannel = createAction(
  (data: {
    name: string
    topic?: string
    description?: string
    visibility?: ChannelVisibility
    memberUserIds?: string[]
  }) => ({
    type: [CREATE_CHANNEL_REQUEST, CREATE_CHANNEL_SUCCESS, CREATE_CHANNEL_FAILURE],
    promise: (api: IApi) => api.channels.create(data),
  }),
)

export const updateChannel = createAction(
  (
    channelId: string,
    data: {
      name?: string
      emoji?: string
      topic?: string
      description?: string
      visibility?: ChannelVisibility
      arcAutoReply?: boolean
    },
  ) => ({
    type: [UPDATE_CHANNEL_REQUEST, UPDATE_CHANNEL_SUCCESS, UPDATE_CHANNEL_FAILURE],
    promise: (api: IApi) => api.channels.update(channelId, data),
    params: { channelId },
  }),
)

export const archiveChannel = createAction((channelId: string, isArchived: boolean) => ({
  type: [ARCHIVE_CHANNEL_REQUEST, ARCHIVE_CHANNEL_SUCCESS, ARCHIVE_CHANNEL_FAILURE],
  promise: (api: IApi) => api.channels.archive(channelId, isArchived),
  params: { channelId },
}))

/**
 * Look up an existing DM without creating one. No reducer case — the caller awaits
 * the answer and acts on it, because the result is a routing decision rather than
 * state worth keeping.
 */
export const findDm = createAction((userIds: string[]) => ({
  type: [FIND_DM_REQUEST, FIND_DM_SUCCESS, FIND_DM_FAILURE],
  promise: (api: IApi) => api.channels.findDm(userIds),
  params: { userIds },
}))

export const openDm = createAction((userIds: string[], arcModel?: string) => ({
  type: [OPEN_DM_REQUEST, OPEN_DM_SUCCESS, OPEN_DM_FAILURE],
  promise: (api: IApi) => api.channels.openDm(userIds, arcModel),
}))

// --- Membership ---

export const joinChannel = createAction((channelId: string) => ({
  type: [JOIN_CHANNEL_REQUEST, JOIN_CHANNEL_SUCCESS, JOIN_CHANNEL_FAILURE],
  promise: (api: IApi) => api.channels.join(channelId),
  params: { channelId },
}))

export const leaveChannel = createAction((channelId: string) => ({
  type: [LEAVE_CHANNEL_REQUEST, LEAVE_CHANNEL_SUCCESS, LEAVE_CHANNEL_FAILURE],
  promise: (api: IApi) => api.channels.leave(channelId),
  params: { channelId },
}))

export const listMembers = createAction((channelId: string) => ({
  type: [LIST_MEMBERS_REQUEST, LIST_MEMBERS_SUCCESS, LIST_MEMBERS_FAILURE],
  promise: (api: IApi) => api.channels.listMembers(channelId),
  params: { channelId },
}))

export const addMembers = createAction((channelId: string, userIds: string[]) => ({
  type: [ADD_MEMBERS_REQUEST, ADD_MEMBERS_SUCCESS, ADD_MEMBERS_FAILURE],
  promise: (api: IApi) => api.channels.addMembers(channelId, userIds),
  params: { channelId },
}))

export const removeMember = createAction((channelId: string, userId: string) => ({
  type: [REMOVE_MEMBER_REQUEST, REMOVE_MEMBER_SUCCESS, REMOVE_MEMBER_FAILURE],
  promise: (api: IApi) => api.channels.removeMember(channelId, userId),
  params: { channelId, userId },
}))

export const createShareLink = createAction((channelId: string) => ({
  type: [CREATE_SHARE_LINK_REQUEST, CREATE_SHARE_LINK_SUCCESS, CREATE_SHARE_LINK_FAILURE],
  promise: (api: IApi) => api.channels.createShareLink(channelId),
  params: { channelId },
}))

export const resolveShareLink = createAction((shareId: string) => ({
  type: [RESOLVE_SHARE_REQUEST, RESOLVE_SHARE_SUCCESS, RESOLVE_SHARE_FAILURE],
  promise: (api: IApi) => api.channels.resolveShareLink(shareId),
  params: { shareId },
}))

export const joinShare = createAction((shareId: string) => ({
  type: [JOIN_SHARE_REQUEST, JOIN_SHARE_SUCCESS, JOIN_SHARE_FAILURE],
  promise: (api: IApi) => api.channels.joinShare(shareId),
  params: { shareId },
}))

export const updateChannelSettings = createAction(
  (
    channelId: string,
    data: {
      isPinned?: boolean
      notificationLevel?: ChannelNotificationLevel
      mutedUntil?: string | null
      overridesGroupMute?: boolean
    },
  ) => ({
    type: [UPDATE_SETTINGS_REQUEST, UPDATE_SETTINGS_SUCCESS, UPDATE_SETTINGS_FAILURE],
    promise: (api: IApi) => api.channels.updateSettings(channelId, data),
    params: { channelId },
  }),
)

// --- Messages ---

/**
 * `before` pages upward. `isBackfill` marks the post-reconnect resync so the
 * reducer merges rather than replaces — see the reducer note on LIST_MESSAGES.
 */
export const listMessages = createAction(
  (
    channelId: string,
    params?: { before?: string; beforeId?: string; limit?: number; isBackfill?: boolean },
  ) => ({
    type: [LIST_MESSAGES_REQUEST, LIST_MESSAGES_SUCCESS, LIST_MESSAGES_FAILURE],
    // Both halves of the cursor travel together — see ListChannelMessages. The
    // timestamp alone steps over messages that share one.
    promise: (api: IApi) =>
      api.channels.listMessages(channelId, {
        before: params?.before,
        beforeId: params?.beforeId,
        limit: params?.limit,
      }),
    params: { channelId, ...params },
  }),
)

/**
 * Load the timeline window around a message, for a deep link whose target is too
 * far back to be in the first page. `channelId` rides along in `params` so the
 * reducer can discard a window that arrives after the user has moved on, the same
 * guard LIST_MESSAGES uses.
 */
export const getMessageContext = createAction((channelId: string, messageId: string) => ({
  type: [GET_MESSAGE_CONTEXT_REQUEST, GET_MESSAGE_CONTEXT_SUCCESS, GET_MESSAGE_CONTEXT_FAILURE],
  promise: (api: IApi) => api.channels.getMessageContext(messageId),
  params: { channelId, messageId },
}))

/**
 * `tempId` is generated by the caller so the optimistic row can be reconciled
 * with the saved message on success (or marked failed on error).
 *
 * `pageUrl` is stamped here rather than passed by each caller. It is the same
 * value for every composer on the page — where the user is standing — and there
 * are five send sites plus the floating bubble, which is precisely the surface
 * that gets used *while* looking at a client. Threading a prop to all of them to
 * carry one global fact would only create places for it to be forgotten. Read
 * from `window.location` for the same reason the Arc chat read `useLocation()`:
 * with a browser-history router they are the same string.
 */
export const currentPageUrl = () => `${window.location.pathname}${window.location.search}`

export const sendMessage = createAction(
  (channelId: string, data: ISendChannelMessageParams, clientMessageId: string) => {
    const payload = {
      ...data,
      clientMessageId,
      pageUrl: currentPageUrl(),
      pageState: arcPageStateFor(channelId),
    }
    return {
      type: [SEND_MESSAGE_REQUEST, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_FAILURE],
      promise: (api: IApi) => api.channels.sendMessage(channelId, payload),
      params: { channelId, tempId: tempIdForClientMessage(clientMessageId), clientMessageId, data },
    }
  },
)

/** The optimistic row's id for a send: never a uuid, so nothing mistakes it for a stored message. */
export const tempIdForClientMessage = (clientMessageId: string): string =>
  `pending-${clientMessageId}`

/** A fresh id for one send, reused by every retry of it so the server stores it once. */
export const makeClientMessageId = (): string =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = Math.floor(Math.random() * 16)
        return (char === 'x' ? random : (random % 4) + 8).toString(16)
      })

/** Drop an unsent message: out of the outbox and off the timeline. */
export const DISCARD_UNSENT_MESSAGE = `${prefix}/DISCARD_UNSENT_MESSAGE`
export const discardUnsentMessage = (clientMessageId: string) => ({
  type: DISCARD_UNSENT_MESSAGE,
  data: { clientMessageId },
})

/** The outbox as it was persisted for this user, restored on sign-in or app start. */
export const HYDRATE_OUTBOX = `${prefix}/HYDRATE_OUTBOX`

/** Where the reader left a conversation's timeline; null when they were at the bottom. */
export const SAVE_SCROLL_POSITION = `${prefix}/SAVE_SCROLL_POSITION`
export const saveScrollPosition = (channelId: string, scrollTop: number | null) => ({
  type: SAVE_SCROLL_POSITION,
  data: { channelId, scrollTop },
})

/** The offline snapshot of the sidebar and recent timelines, restored before first render. */
export const HYDRATE_CHANNELS_SNAPSHOT = `${prefix}/HYDRATE_CHANNELS_SNAPSHOT`

export const [PREFETCH_MESSAGES_REQUEST, PREFETCH_MESSAGES_SUCCESS, PREFETCH_MESSAGES_FAILURE] =
  createRequestTypes(prefix, 'PREFETCH_MESSAGES')

/** Warm the timeline cache for a conversation the reader is likely to open next. */
export const prefetchMessages = createAction((channelId: string) => ({
  type: [PREFETCH_MESSAGES_REQUEST, PREFETCH_MESSAGES_SUCCESS, PREFETCH_MESSAGES_FAILURE],
  // Background work the reader never asked for: a failure must not raise an error toast.
  promise: (api: IApi) =>
    api.channels.listMessages(channelId, {}).catch((error: Error & { data?: object }) => {
      throw Object.assign(error, { data: { ...(error.data ?? {}), isSilent: true } })
    }),
  params: { channelId },
}))

/**
 * Post a recorded voice memo. No optimistic row: the memo has no attachment to
 * play until the upload lands, so the composer shows it sending instead. The saved
 * message is reconciled the same way SEND_MESSAGE_SUCCESS reconciles a typed one.
 */
export const sendVoiceMemo = createAction(
  (channelId: string, data: Omit<ISendVoiceMemoParams, 'pageUrl'>) => ({
    type: [SEND_VOICE_MEMO_REQUEST, SEND_VOICE_MEMO_SUCCESS, SEND_VOICE_MEMO_FAILURE],
    promise: (api: IApi) =>
      api.channels.sendVoiceMemo(channelId, { ...data, pageUrl: currentPageUrl() }),
    params: { channelId },
  }),
)

/** Answers with the whole message, applied like an edit. */
export const retryVoiceMemoTranscription = createAction((attachmentId: string) => ({
  type: [
    RETRY_VOICE_MEMO_TRANSCRIPTION_REQUEST,
    RETRY_VOICE_MEMO_TRANSCRIPTION_SUCCESS,
    RETRY_VOICE_MEMO_TRANSCRIPTION_FAILURE,
  ],
  promise: (api: IApi) => api.channels.retryVoiceMemoTranscription(attachmentId),
  params: { attachmentId },
}))

/**
 * Start an ad-hoc Zoom meeting for a conversation.
 *
 * No reducer case: the server posts the join card itself, so it arrives through
 * the normal message broadcast. The caller awaits this only to disable its button
 * while it is in flight and to report a failure.
 */
export const startZoomMeeting = createAction((channelId: string) => ({
  type: [START_ZOOM_MEETING_REQUEST, START_ZOOM_MEETING_SUCCESS, START_ZOOM_MEETING_FAILURE],
  promise: (api: IApi) => api.channels.startZoomMeeting(channelId),
  params: { channelId },
}))

export const editMessage = createAction(
  (messageId: string, data: { contentState?: RawDraftContentState; content?: string }) => ({
    type: [EDIT_MESSAGE_REQUEST, EDIT_MESSAGE_SUCCESS, EDIT_MESSAGE_FAILURE],
    promise: (api: IApi) => api.channels.editMessage(messageId, data),
    params: { messageId },
  }),
)

export const deleteMessage = createAction((messageId: string) => ({
  type: [DELETE_MESSAGE_REQUEST, DELETE_MESSAGE_SUCCESS, DELETE_MESSAGE_FAILURE],
  promise: (api: IApi) => api.channels.deleteMessage(messageId),
  params: { messageId },
}))

/**
 * Drop the link unfurl from a message. The server answers with the whole message,
 * `linkPreview` already withheld, so the reducer's merge clears the card without the
 * client having to model dismissal separately.
 */
export const dismissLinkPreview = createAction((messageId: string) => ({
  type: [DISMISS_LINK_PREVIEW_REQUEST, DISMISS_LINK_PREVIEW_SUCCESS, DISMISS_LINK_PREVIEW_FAILURE],
  promise: (api: IApi) => api.channels.dismissLinkPreview(messageId),
  params: { messageId },
}))

/**
 * Create the task a conversation's prompt offered, or dismiss the prompt. Both
 * answer with the anchor message, prompt state included, merged like a dismissed
 * link preview.
 */
export const acceptTaskSuggestion = createAction((suggestionId: string) => ({
  type: [
    ACCEPT_TASK_SUGGESTION_REQUEST,
    ACCEPT_TASK_SUGGESTION_SUCCESS,
    ACCEPT_TASK_SUGGESTION_FAILURE,
  ],
  promise: (api: IApi) => api.channels.acceptTaskSuggestion(suggestionId),
  params: { suggestionId },
}))

export const dismissTaskSuggestion = createAction((suggestionId: string) => ({
  type: [
    DISMISS_TASK_SUGGESTION_REQUEST,
    DISMISS_TASK_SUGGESTION_SUCCESS,
    DISMISS_TASK_SUGGESTION_FAILURE,
  ],
  promise: (api: IApi) => api.channels.dismissTaskSuggestion(suggestionId),
  params: { suggestionId },
}))

/** A keepalive mark-read sent as the page went away; no reply comes back to dispatch. */
export const MARKED_READ_ON_PAGE_LEAVE = `${prefix}/MARKED_READ_ON_PAGE_LEAVE`
export const markedReadOnPageLeave = (channelId: string) => ({
  type: MARKED_READ_ON_PAGE_LEAVE,
  params: { channelId },
})

export const markRead = createAction((channelId: string, messageId?: string) => ({
  type: [MARK_READ_REQUEST, MARK_READ_SUCCESS, MARK_READ_FAILURE],
  promise: (api: IApi) => api.channels.markRead(channelId, messageId),
  params: { channelId },
}))

/**
 * Rewinds the channel badge to this message. The mirror image of `markRead`, and
 * the only thing that moves the cursor backwards.
 *
 * With no `messageId` the badge rewinds to the conversation's newest message and so
 * comes back reading one — what the sidebar's swipe gesture asks for, since a row
 * carries `lastMessageAt` and no message id.
 */
export const markUnread = createAction((channelId: string, messageId?: string) => ({
  type: [MARK_UNREAD_REQUEST, MARK_UNREAD_SUCCESS, MARK_UNREAD_FAILURE],
  promise: (api: IApi) => api.channels.markUnread(channelId, messageId),
  params: { channelId, messageId },
}))

export const searchMessages = createAction((params: ISearchMessagesParams) => ({
  type: [SEARCH_MESSAGES_REQUEST, SEARCH_MESSAGES_SUCCESS, SEARCH_MESSAGES_FAILURE],
  promise: (api: IApi) => api.channels.search(params),
  params,
}))

export const searchConversations = createAction((params: ISearchConversationsParams) => ({
  type: [SEARCH_CONVERSATIONS_REQUEST, SEARCH_CONVERSATIONS_SUCCESS, SEARCH_CONVERSATIONS_FAILURE],
  promise: (api: IApi) => api.channels.searchConversations(params),
  params,
}))

/**
 * Uploads one file and resolves with its Box metadata. The caller stages that
 * until send rather than the reducer holding it — an in-flight attachment
 * belongs to the composer that started it, not to global channel state.
 */
export const uploadChannelAttachment = createAction((channelId: string, file: File) => ({
  type: [UPLOAD_ATTACHMENT_REQUEST, UPLOAD_ATTACHMENT_SUCCESS, UPLOAD_ATTACHMENT_FAILURE],
  promise: (api: IApi) => api.channels.uploadAttachment(channelId, file),
  params: { channelId },
}))

// Resolving an attachment's viewable link lives in `redux/box/actions` as
// `getChannelAttachmentEmbedLink`, not here: what comes back is a Box *embed*
// URL that only renders inside BoxViewer's iframe, so it has to feed the box
// slice's GET_EMBED_LINK loading/success/failure states the viewer already
// reads. Nothing about it belongs in channel state — the URL expires in
// minutes, so caching it would be worse than not caching.

// --- Pins ---

export const pinMessage = createAction((messageId: string, isPinned: boolean) => ({
  type: [PIN_MESSAGE_REQUEST, PIN_MESSAGE_SUCCESS, PIN_MESSAGE_FAILURE],
  promise: (api: IApi) => api.channels.pinMessage(messageId, isPinned),
  params: { messageId, isPinned },
}))

/**
 * Rehydrate Arc's reasoning for a message. Fetched lazily, only where Arc actually
 * worked, so the timeline never pays for the session join.
 */
export const getChannelArcProgress = createAction((messageId: string) => ({
  type: [ARC_PROGRESS_REQUEST, ARC_PROGRESS_SUCCESS, ARC_PROGRESS_FAILURE],
  promise: (api: IApi) => api.channels.arcProgress(messageId),
  params: { messageId },
}))

/**
 * Every Arc run still in flight in a channel, asked for on open.
 *
 * `arcProgress` is dropped when the active channel changes and rebuilt from live
 * events alone, so a run that was already going had nothing to redraw it. The
 * per-message fetch above can't close that gap on its own: in a conversation Arc
 * answers inline, so a run is keyed on the human message that triggered it, and
 * the client has no reason to ask about that message — or about a teammate's run
 * it never saw start. This asks the channel instead of guessing at ids.
 */
export const listChannelArcRuns = createAction((channelId: string) => ({
  type: [ARC_RUNS_REQUEST, ARC_RUNS_SUCCESS, ARC_RUNS_FAILURE],
  promise: (api: IApi) => api.channels.arcRuns(channelId),
  // Stamped so the reducer can tell whether the response that lands is still the
  // newest one asked for. This answer is authoritative in both directions, so an
  // overtaken one does not merely go stale — it settles runs that have started
  // since. See the ARC_RUNS_SUCCESS case.
  params: { channelId, requestId: crypto.randomUUID() },
}))

/**
 * Hydrate the live plan panel for a conversation's Arc session.
 *
 * The plan lands in the `atlasai` store, not this one: `PlanProgressPanel` reads
 * it from there and the websocket pushes it there too, so a second copy keyed the
 * other way would be two sources of truth for one panel. The atlasai `plan`
 * reducer handles this action directly — see the cross-domain case there.
 */
export const getChannelArcPlan = createAction((sessionId: string) => ({
  type: [ARC_PLAN_REQUEST, ARC_PLAN_SUCCESS, ARC_PLAN_FAILURE],
  promise: (api: IApi) => api.channels.arcPlan(sessionId),
  // Each dispatch is stamped so its response can be recognised when it lands.
  // Two requests for one session overlap whenever somebody leaves a conversation
  // and comes back while the first is still in flight, and without identity the
  // reducer cannot tell which of them a live event overtook — see the plan slice.
  params: { sessionId, requestId: crypto.randomUUID() },
}))

/**
 * Stop the Arc run working this conversation.
 *
 * The spinner is not cleared here. Everyone watching learns the run stopped from
 * the same `CHANNEL_ARC_CANCELLED` event, so the person who pressed Stop takes
 * the identical path as everybody else — one code path to be right rather than an
 * optimistic local clear that can disagree with the room.
 */
export const cancelChannelArcRun = createAction((sessionId: string, turnId?: string | null) => ({
  type: [CANCEL_ARC_RUN_REQUEST, CANCEL_ARC_RUN_SUCCESS, CANCEL_ARC_RUN_FAILURE],
  promise: (api: IApi) => api.channels.cancelArcRun(sessionId, turnId),
  params: { sessionId, turnId },
}))

// --- Reactions ---

export const addReaction = createAction((messageId: string, emoji: string) => ({
  type: [ADD_REACTION_REQUEST, ADD_REACTION_SUCCESS, ADD_REACTION_FAILURE],
  promise: (api: IApi) => api.channels.addReaction(messageId, emoji),
  params: { messageId, emoji },
}))

export const removeReaction = createAction((messageId: string, emoji: string) => ({
  type: [REMOVE_REACTION_REQUEST, REMOVE_REACTION_SUCCESS, REMOVE_REACTION_FAILURE],
  promise: (api: IApi) => api.channels.removeReaction(messageId, emoji),
  params: { messageId, emoji },
}))

// --- Local ---

export const setActiveChannel = (channelId: string | null) => ({
  type: SET_ACTIVE_CHANNEL,
  data: { channelId },
})

/**
 * Open a conversation beside the main one, at `index` among the split panes. A
 * conversation already in a pane moves to that slot instead.
 */
export const openSplitPane = (channelId: string, index: number) => ({
  type: OPEN_SPLIT_PANE,
  data: { channelId, index },
})

export const closeSplitPane = (channelId: string) => ({
  type: CLOSE_SPLIT_PANE,
  data: { channelId },
})

/** Every pane at once — the surface going away, or a layout with no room for them. */
export const closeSplitPanes = () => ({ type: CLOSE_SPLIT_PANES })

/** A record page's own conversation, held apart from the main one so AIM's panel can open beside it. */
export const openEmbeddedConversation = (channelId: string) => ({
  type: OPEN_EMBEDDED_CONVERSATION,
  data: { channelId },
})

export const closeEmbeddedConversation = (channelId: string) => ({
  type: CLOSE_EMBEDDED_CONVERSATION,
  data: { channelId },
})

export const setEmbeddedSidePanel = (channelId: string, panel: ChannelSidePanel) => ({
  type: SET_EMBEDDED_SIDE_PANEL,
  data: { channelId, panel },
})

export const invalidateLoadedConversations = () => ({ type: INVALIDATE_LOADED_CONVERSATIONS })

export const clearSearch = () => ({ type: CLEAR_SEARCH })

/** "Do nothing" on the offer to add people an unreachable @-mention named. */
export const dismissMentionInvite = () => ({ type: DISMISS_MENTION_INVITE })

/** Participant sets the caller holds named conversations with — one sidebar row each. */
export const listConversationGroups = createAction(() => ({
  type: [
    LIST_CONVERSATION_GROUPS_REQUEST,
    LIST_CONVERSATION_GROUPS_SUCCESS,
    LIST_CONVERSATION_GROUPS_FAILURE,
  ],
  promise: (api: IApi) => api.channels.listConversationGroups(),
}))

/**
 * The conversations inside one group. `dmKey` and `loadMore` ride in `params` so
 * the reducer can tell which group a response belongs to and whether to append —
 * two groups can be expanded at once, and their responses can land out of order.
 */
export const listConversations = createAction(
  (params: {
    /** Exactly one — a participant set, an automation's runs, or a channel. */
    dmKey?: string
    automationId?: string
    parentChannelId?: string
    search?: string
    offset?: number
    loadMore?: boolean
  }) => ({
    type: [LIST_CONVERSATIONS_REQUEST, LIST_CONVERSATIONS_SUCCESS, LIST_CONVERSATIONS_FAILURE],
    promise: (api: IApi) =>
      api.channels.listConversations({
        dmKey: params.dmKey,
        automationId: params.automationId,
        parentChannelId: params.parentChannelId,
        search: params.search,
        offset: params.offset,
      }),
    params,
  }),
)

/**
 * The Conversations section: everything recent across every grouping, unread
 * first.
 *
 * Unparameterised by group on purpose — it is one flat list, and it is the only
 * place unread surfaces now that the Channels and People rows carry no badges.
 */
export interface IRecentConversationsParams {
  search?: string
  /** Filled in by threadsWindowMiddleware when a caller leaves them out. */
  filter?: ThreadsFilter
  recentCount?: number
}

export const listRecentConversations = createAction((params: IRecentConversationsParams = {}) => ({
  type: [
    LIST_RECENT_CONVERSATIONS_REQUEST,
    LIST_RECENT_CONVERSATIONS_SUCCESS,
    LIST_RECENT_CONVERSATIONS_FAILURE,
  ],
  promise: (api: IApi) =>
    api.channels.listRecentConversations({
      search: params.search,
      filter: params.filter,
      recentCount: params.recentCount,
    }),
  params,
}))

/** Switch the Threads filter; the window starts over from the first page. */
export const setThreadsFilter = (filter: ThreadsFilter) => ({
  type: SET_THREADS_FILTER,
  data: { filter },
})

/** "Show more threads": grow the window by a page. */
export const showMoreThreads = () => ({ type: SHOW_MORE_THREADS })

/** "Show fewer threads": back to the first page. */
export const showFewerThreads = () => ({ type: SHOW_FEWER_THREADS })

/**
 * Pin or unpin anything the sidebar lists.
 *
 * One action for all three target kinds, mirroring the one endpoint: a pin is
 * the same act whatever it points at, and the Pinned section reads them as one
 * list. `params` carries the target so the reducer can patch whichever slice
 * holds that row without being told which one that is.
 */
export const setPin = createAction(
  (targetType: AimPinTargetType, targetId: string, isPinned: boolean) => ({
    type: [SET_PIN_REQUEST, SET_PIN_SUCCESS, SET_PIN_FAILURE],
    promise: (api: IApi) => api.channels.setPin({ targetType, targetId, isPinned }),
    params: { targetType, targetId, isPinned },
  }),
)

/**
 * Put a conversation away until someone posts in it again.
 *
 * `channelId` rides in `params` so the reducer can drop the row without waiting
 * for a refetch — an archive that leaves the row on screen reads as a no-op.
 */
export const archiveConversation = createAction((channelId: string, isArchived: boolean) => ({
  type: [ARCHIVE_CONVERSATION_REQUEST, ARCHIVE_CONVERSATION_SUCCESS, ARCHIVE_CONVERSATION_FAILURE],
  promise: (api: IApi) => api.channels.archiveConversation(channelId, isArchived),
  params: { channelId, isArchived },
}))

/** Everyone on the team — the People directory. */
export const listPeople = createAction((params: { search?: string } = {}) => ({
  type: [LIST_PEOPLE_REQUEST, LIST_PEOPLE_SUCCESS, LIST_PEOPLE_FAILURE],
  promise: (api: IApi) => api.channels.listPeopleDirectory({ search: params.search }),
  params,
}))

/**
 * Start a conversation inside a channel — the `+` on a channel row.
 *
 * `channelId` rides in `params` so the reducer can drop the new row into that
 * channel's group without refetching the group it belongs to.
 */
export const createChannelConversation = createAction((channelId: string, name?: string) => ({
  type: [
    CREATE_CHANNEL_CONVERSATION_REQUEST,
    CREATE_CHANNEL_CONVERSATION_SUCCESS,
    CREATE_CHANNEL_CONVERSATION_FAILURE,
  ],
  promise: (api: IApi) => api.channels.createChannelConversation(channelId, name),
  params: { channelId },
}))

/**
 * A channel's homepage — its conversations, tasks, pins and files.
 *
 * `params` carries the whole request, not just the target: the reducer matches a
 * response against the request still outstanding, and search and load-more race
 * on a single target the same way navigation races across two.
 */
export const getChannelHome = createAction(
  (channelId: string, conversationLimit?: number, search?: string) => ({
    type: [GET_CHANNEL_HOME_REQUEST, GET_CHANNEL_HOME_SUCCESS, GET_CHANNEL_HOME_FAILURE],
    promise: (api: IApi) => api.channels.getChannelHome(channelId, conversationLimit, search),
    params: { channelId, conversationLimit, search },
  }),
)

/** The same four blocks for a teammate, relative to the viewer. */
export const getPersonHome = createAction(
  (userId: string, conversationLimit?: number, search?: string) => ({
    type: [GET_PERSON_HOME_REQUEST, GET_PERSON_HOME_SUCCESS, GET_PERSON_HOME_FAILURE],
    promise: (api: IApi) => api.channels.getPersonHome(userId, conversationLimit, search),
    params: { userId, conversationLimit, search },
  }),
)

export const [
  GET_SPLIT_PERSON_HOME_REQUEST,
  GET_SPLIT_PERSON_HOME_SUCCESS,
  GET_SPLIT_PERSON_HOME_FAILURE,
] = createRequestTypes(prefix, 'GET_SPLIT_PERSON_HOME')

/** A teammate's homepage for a split pane, which keeps it: the store's one slot is the main column's. */
export const getSplitPersonHome = createAction(
  (userId: string, conversationLimit?: number, search?: string) => ({
    type: [
      GET_SPLIT_PERSON_HOME_REQUEST,
      GET_SPLIT_PERSON_HOME_SUCCESS,
      GET_SPLIT_PERSON_HOME_FAILURE,
    ],
    promise: (api: IApi) => api.channels.getPersonHome(userId, conversationLimit, search),
    params: { userId, conversationLimit, search },
  }),
)

/** Arc's homepage — its conversations and scheduled automations. */
export const getArcHome = createAction((conversationLimit?: number, search?: string) => ({
  type: [GET_ARC_HOME_REQUEST, GET_ARC_HOME_SUCCESS, GET_ARC_HOME_FAILURE],
  promise: (api: IApi) => api.channels.getArcHome(conversationLimit, search),
  params: { conversationLimit, search },
}))

/**
 * Write the shared notepad. `content` rides in `params` so the reducer can show
 * the save immediately — the notepad debounces, and a round trip after that
 * would make the timestamp lag the text you can already see.
 */
export const saveAimNote = createAction(
  (
    scopeType: AimNoteScopeType,
    scopeId: string,
    content: string,
    contentState?: RawDraftContentState | null,
  ) => ({
    type: [SAVE_AIM_NOTE_REQUEST, SAVE_AIM_NOTE_SUCCESS, SAVE_AIM_NOTE_FAILURE],
    promise: (api: IApi) => api.channels.saveAimNote(scopeType, scopeId, content, contentState),
    // Scope included: the reducer patches the one homepage this notepad belongs
    // to, and cannot tell them apart from the content alone.
    params: { scopeType, scopeId, content, contentState },
  }),
)

/**
 * Identity for one Arc-model write, so the reducer can tell a refused write that
 * still owns the picker from one a later pick has already replaced. A counter
 * rather than a uuid: it only has to be unique within a page's lifetime, and it
 * reads plainly in a test.
 */
let arcModelRequestSeq = 0

/** Tail of each conversation's write chain — see `queueArcModelWrite`. */
const arcModelWrites = new Map<string, Promise<unknown>>()

/**
 * Hold a conversation's Arc-model writes to one at a time.
 *
 * `SetArcModel` is an unconditional update, so two writes in flight settle the row
 * in whatever order they reach the server — which the client does not control. The
 * row could then hold the earlier pick while the picker shows the later one, and
 * nothing downstream can notice: a write's response says only that it succeeded,
 * never what the row now holds.
 *
 * Per conversation, because that is the granularity of the row being written.
 */
const queueArcModelWrite = <R>(channelId: string, write: () => Promise<R>): Promise<R> => {
  const previous = arcModelWrites.get(channelId) ?? Promise.resolve()
  const result = previous.then(write)
  // The queued tail swallows the rejection, so a refused write releases the next
  // pick instead of stranding every one behind it. Only the promise handed back
  // rejects, which is what makes the middleware dispatch FAILURE.
  const settled: Promise<unknown> = result.catch((): void => undefined)
  let tail: Promise<unknown>
  tail = settled.then(() => {
    // Dropped only when nothing has queued behind it, so the map holds a chain
    // per live burst rather than an entry per conversation ever visited.
    if (arcModelWrites.get(channelId) === tail) arcModelWrites.delete(channelId)
  })
  arcModelWrites.set(channelId, tail)
  return result
}

/**
 * Pick the model Arc runs on in this conversation. `params` carries the choice so
 * the reducer can update the open channel without waiting for a refetch, plus
 * `requestId` so only the write currently on screen is undone when one is refused.
 * What a refusal rolls back to is tracked by the reducer, not sent from here: the
 * caller can only see the optimistic value, which is the wrong thing to restore.
 */
export const setChannelArcModel = createAction((channelId: string, model: string | null) => ({
  type: [SET_ARC_MODEL_REQUEST, SET_ARC_MODEL_SUCCESS, SET_ARC_MODEL_FAILURE],
  promise: (api: IApi) =>
    queueArcModelWrite(channelId, () => api.channels.setArcModel(channelId, model)),
  params: { channelId, model, requestId: ++arcModelRequestSeq },
}))

/** Automations the caller has scheduled runs for — one sidebar row each. */
export const listScheduledRunGroups = createAction(() => ({
  type: [
    LIST_SCHEDULED_RUN_GROUPS_REQUEST,
    LIST_SCHEDULED_RUN_GROUPS_SUCCESS,
    LIST_SCHEDULED_RUN_GROUPS_FAILURE,
  ],
  promise: (api: IApi) => api.channels.listScheduledRunGroups(),
}))

// --- Scheduled messages ---
// Every success answers with the row as it now stands, and the reducer files it (or
// drops it once settled) the same way it handles the CHANNEL_SCHEDULED_MESSAGE_CHANGED
// frame the server sends the sender's other tabs.

export const listScheduledMessages = createAction(() => ({
  type: [
    LIST_SCHEDULED_MESSAGES_REQUEST,
    LIST_SCHEDULED_MESSAGES_SUCCESS,
    LIST_SCHEDULED_MESSAGES_FAILURE,
  ],
  promise: (api: IApi) => api.channels.listScheduledMessages(),
}))

export const scheduleMessage = createAction(
  (channelId: string, data: IScheduleChannelMessageParams) => ({
    type: [SCHEDULE_MESSAGE_REQUEST, SCHEDULE_MESSAGE_SUCCESS, SCHEDULE_MESSAGE_FAILURE],
    promise: (api: IApi) => api.channels.scheduleMessage(channelId, data),
    params: { channelId },
  }),
)

export const scheduleFirstMessage = createAction((data: IScheduleFirstMessageParams) => ({
  type: [SCHEDULE_MESSAGE_REQUEST, SCHEDULE_MESSAGE_SUCCESS, SCHEDULE_MESSAGE_FAILURE],
  promise: (api: IApi) => api.channels.scheduleFirstMessage(data),
}))

export const uploadScheduledAttachment = createAction((file: File) => ({
  type: [UPLOAD_ATTACHMENT_REQUEST, UPLOAD_ATTACHMENT_SUCCESS, UPLOAD_ATTACHMENT_FAILURE],
  promise: (api: IApi) => api.channels.uploadScheduledAttachment(file),
}))

export const updateScheduledMessage = createAction(
  (scheduledMessageId: string, data: IUpdateScheduledChannelMessageParams) => ({
    type: [
      UPDATE_SCHEDULED_MESSAGE_REQUEST,
      UPDATE_SCHEDULED_MESSAGE_SUCCESS,
      UPDATE_SCHEDULED_MESSAGE_FAILURE,
    ],
    promise: (api: IApi) => api.channels.updateScheduledMessage(scheduledMessageId, data),
    params: { scheduledMessageId },
  }),
)

export const cancelScheduledMessage = createAction((scheduledMessageId: string) => ({
  type: [
    CANCEL_SCHEDULED_MESSAGE_REQUEST,
    CANCEL_SCHEDULED_MESSAGE_SUCCESS,
    CANCEL_SCHEDULED_MESSAGE_FAILURE,
  ],
  promise: (api: IApi) => api.channels.cancelScheduledMessage(scheduledMessageId),
  params: { scheduledMessageId },
}))

export const sendScheduledMessageNow = createAction((scheduledMessageId: string) => ({
  type: [
    SEND_SCHEDULED_MESSAGE_NOW_REQUEST,
    SEND_SCHEDULED_MESSAGE_NOW_SUCCESS,
    SEND_SCHEDULED_MESSAGE_NOW_FAILURE,
  ],
  promise: (api: IApi) => api.channels.sendScheduledMessageNow(scheduledMessageId),
  params: { scheduledMessageId },
}))

/**
 * Resolve one attachment to something renderable — a data URL for S3-backed files,
 * a Box embed URL for the older ones.
 *
 * Deliberately has no reducer case: the caller awaits it and holds the result in
 * local state. An S3 link is the file's bytes inline, and parking a data URL per
 * image in a channel's whole history in the store would be a memory leak with a
 * selector attached.
 *
 * Retried and deduplicated by `fetchAttachmentLink`, which is below the middleware
 * — the only side of it that sees a rejection at all, since a caller awaiting this
 * gets the FAILURE action rather than a throw. So a failure here means every attempt
 * failed, and it is reported (and toasted) once rather than per attempt.
 */
export const getChannelAttachmentLink = createAction((attachmentId: string) => ({
  type: [ATTACHMENT_LINK_REQUEST, ATTACHMENT_LINK_SUCCESS, ATTACHMENT_LINK_FAILURE],
  promise: (api: IApi) => fetchAttachmentLink(api, attachmentId),
  params: { attachmentId },
}))

/**
 * A signed URL a video streams from, since it is too big to ride as a data URL. No
 * reducer case, for the same reason as `getChannelAttachmentLink`.
 */
export const getChannelAttachmentVideoUrl = createAction((attachmentId: string) => ({
  type: [ATTACHMENT_VIDEO_URL_REQUEST, ATTACHMENT_VIDEO_URL_SUCCESS, ATTACHMENT_VIDEO_URL_FAILURE],
  promise: (api: IApi) => api.channels.getAttachmentVideoUrl(attachmentId),
  params: { attachmentId },
}))

/** Which auxiliary panel the conversation view shows, if any. */
export type ChannelSidePanel = 'search' | 'members' | 'scheduled' | null

export const setSidePanel = (panel: ChannelSidePanel) => ({
  type: SET_SIDE_PANEL,
  data: { panel },
})

// --- Typing (sent over the socket, not HTTP) ---

/**
 * Typing goes over the WebSocket because it is high-frequency and disposable —
 * an HTTP round trip per keystroke window would be wasteful, and a dropped one
 * costs nothing. Everything that must not be lost (messages) goes over HTTP.
 *
 * Only the channel is sent. The sender's id, name and avatar are all stamped
 * server-side from the authenticated socket and the sender's own record — a
 * client-supplied display name is a claim the server has no reason to take.
 */
export const sendTypingStart = (channelId: string) => ({
  type: WS_SEND_MESSAGE,
  payload: { type: CHANNEL_TYPING_START, data: { channelId } },
})

export const sendTypingStop = (channelId: string) => ({
  type: WS_SEND_MESSAGE,
  payload: { type: CHANNEL_TYPING_STOP, data: { channelId } },
})
